
import { Component, Vue, Watch } from 'vue-property-decorator'
import { getWhiteNoticeB, setWhiteNoticeB } from '@/api/iousServices'
@Component({
  name: 'whitePayPopup'
})
export default class whitePayPopup extends Vue {
  showResult = false

  whiteNoticeTipList: Array<{
    autoId: string
    dataId: string
    dataName: string
  }> = []

  @Watch('showResult')
  onShowResultChange() {
    this.changeNativeAreaColor(this.showResult)
  }

  created() {
    this.getWhiteNoticeB()
  }

  getWhiteNoticeB() {
    getWhiteNoticeB().then((res) => {
      if (res.data.isNotice === 1) {
        this.showResult = true
        this.whiteNoticeTipList = res.data.whiteNoticeTipList || []
      }else {
        this.showResult = false
      }
    })
  }
  handleClick() {
    setWhiteNoticeB().finally(() => {
      this.showResult = false
    })
  }

  changeNativeAreaColor (isShow: boolean) {
    const params = {
      statusBarColor: isShow ? '000000' : 'FFFFFF',  // 状态栏颜色
      bottomColor: isShow ? '000000' : 'FFFFFF', // 底部安全区颜色
      alpha: isShow ? 0.7 : 1
    }
    this.$bridge.callHandler('changeNativeAreaColor', params, (res) => {
    })
  }
}
